import gameIds from '../../hub/data/GameIds';

export const DISTRACTOR_TRAIT_NAME = 'trash';
export const GAME_ID = gameIds.BEST_BUDDY;
export const ITEM_MASTERY_THRESHOLD = 2 / 3;
export const LEVEL_COUNT = 14;
export const LEVEL_NUM_FOUR_BUDDIES = 6; // level number where user can now choose from four buddies (as opposed to three)
export const LEVEL_NUM_THREE_CLUBS = 4; // the first level with three clubs to choose from
export const LEVEL_NUM_DISTRACTOR_INTRO = 7; // the first level distractors are introduced in
export const LEVELS_WITH_INTRO_ONBOARDING = [0, 3, 6, 8, 10, 12];
export const LEVELS_WITH_DISTRACTOR_ONBOARDING = [6, 8, 10];
export const MAX_NUM_CLUE_ATTEMPTS = 2; // number of attempts before user is forced to choose correct trait
export const ALYX_PRAISE_PERIOD = 3; // don't play Alyx praise every time, number of correct answers needed to get next one

export const FRIENDS_STATE = {
  BFF: 'BFF',
  BUDDY: 'BUDDY',
  INCOMPLETE: 'INCOMPLETE',
};

export const HAPPINESS_STATE = {
  NEUTRAL: 0,
  HAPPY_1: 1,
  HAPPY_2: 2,
  HAPPY_3: 3,
  HAPPY_4: 4,
};

export const PLAY_AREAS = {
  CHOOSE_CLUB: 'CHOOSE_CLUB',
  FRIEND_COMPLETE: 'FRIEND_COMPLETE',
  FRIENDS: 'FRIENDS',
  LEVEL_COMPLETE: 'LEVEL_COMPLETE',
};

export const THREE_CLUBS_LEVELS = [3];

// Dearest Amplify, sorry about that cross-game Redux bug in RT/TT.
// As my penance, action types are prepended with gameId
export const REDUX_ACTIONS = {
  SET_INTERACTIONS_ENABLED: `${GAME_ID}/SET_INTERACTIONS_ENABLED`,
  SET_INTRO_ONBOARDING_FINISHED: `${GAME_ID}/SET_INTRO_ONBOARDING_FINISHED`,
  SET_ALYX_SPEAKING: `${GAME_ID}/SET_ALYX_SPEAKING`,
  ADD_CORRECT_TRAIT: `${GAME_ID}/ADD_CORRECT_TRAIT`,
  ADD_INCORRECT_TRAIT: `${GAME_ID}/ADD_INCORRECT_TRAIT`,
  INCREMENT_CORRECT_COUNT: `${GAME_ID}/INCREMENT_CORRECT_COUNT`,
  CHANGE_PLAY_AREA: `${GAME_ID}/CHANGE_PLAY_AREA`,
  CHANGE_SCREEN: `${GAME_ID}/CHANGE_SCREEN`,
  GO_TO_NEXT_CLUE: `${GAME_ID}/GO_TO_NEXT_CLUE`,
  HIGHLIGHT_DICTIONARY: `${GAME_ID}/HIGHLIGHT_DICTIONARY`,
  INCREMENT_ALYX_CLICK_COUNT: `${GAME_ID}/INCREMENT_ALYX_CLICK_COUNT`,
  INCREMENT_CLUB_COUNT: `${GAME_ID}/INCREMENT_CLUB_COUNT`,
  INCREMENT_CLUE_NUM_ATTEMPTS: `${GAME_ID}/INCREMENT_CLUE_NUM_ATTEMPTS`,
  INCREMENT_QUESTION_COUNT: `${GAME_ID}/INCREMENT_QUESTION_COUNT`,
  LEAVE_BUDDY_EARLY: `${GAME_ID}/LEAVE_BUDDY_EARLY`,
  RESET_ALYX_CLICK_COUNT: `${GAME_ID}/RESET_ALYX_CLICK_COUNT`,
  RESET_CURRENT_FRIEND: `${GAME_ID}/RESET_CURRENT_FRIEND`,
  RESET_CURRENT_LEVEL: `${GAME_ID}/RESET_CURRENT_LEVEL`,
  RESET_CURRENT_SCORE: `${GAME_ID}/RESET_CURRENT_SCORE`,
  RESET_FRIENDS_TO_SCORE: `${GAME_ID}/RESET_FRIENDS_TO_SCORE`,
  RESET_SELECTED_TRAIT: `${GAME_ID}/RESET_SELECTED_TRAIT`,
  SELECT_CLUES: `${GAME_ID}/SELECT_CLUES`,
  SELECT_FRIEND: `${GAME_ID}/SELECT_FRIEND`,
  SELECT_LEVEL: `${GAME_ID}/SELECT_LEVEL`,
  SELECT_TRAIT: `${GAME_ID}/SELECT_TRAIT`,
  SET_FRIEND_SCORE: `${GAME_ID}/SET_FRIEND_SCORE`,
  SET_FRIEND_STATE: `${GAME_ID}/SET_FRIEND_STATE`,
  SET_HIGHEST_LEVEL_EARNED: `${GAME_ID}/SET_HIGHEST_LEVEL_EARNED`,
  TOGGLE_DEFINITION_MODE: `${GAME_ID}/TOGGLE_DEFINITION_MODE`,
  TOGGLE_FRIEND_COMPLETE_MODAL: `${GAME_ID}/TOGGLE_FRIEND_COMPLETE_MODAL`,
  REPLAY_ONBOARDING: `${GAME_ID}/REPLAY_ONBOARDING`,
  FAIL_TO_PLACE_FRIEND: `${GAME_ID}/FAIL_TO_PLACE_FRIEND`,
  QUICK_ROUND: `${GAME_ID}/QUICK_ROUND`,
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
  LEVEL_LOADING: 'LEVEL_LOADING',
};

// style constants
export const STYLE = {
  BOX_LEFT_MARGINS: [0, 40, 30],
  CLUB_FACE: {
    height: 305,
    width: 245,
  },
  CLUB_ICON: {
    height: 39,
    width: 39,
  },
  FRIEND_WINDOW: {
    height: 160,
    width: 177,
  },
};
